<!-- 日志报表页面 -->
<template>
    <div class="fuzzy-matching-box">
      <div class="fuzzy-matching-top">
        <!-- <el-row class="top-first-line">
          <el-col :span="5">
              <el-form-item label="IMEI：">
                <el-input v-model="Dform.titleValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
              <el-form-item label="名称：">
                <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
          </el-col >
          <el-col :span="5">
          </el-col >
    
        </el-row> -->
        <!-- <h1 class="titleStyle">日志报表</h1> -->
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
              <el-form-item label="IMEI：">
                <el-input v-model="Dform.titleValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
              <el-form-item label="名称：">
                <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
            <el-col :span="5">
              <el-form-item label="开始时间：">
                <el-date-picker
                    v-model="Dform.startTime"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
          </el-col >
            <el-col :span="5">
              <el-form-item label="结束时间：">
                <el-date-picker
                    v-model="Dform.terminalTime"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col >
     
          <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
        </el-row>
      </div>
  
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
           <el-table
           stripe
          :border="true"
           class="table-Style"
           v-loading="loading"
           :header-cell-style="{background:'#EDF6FF',color:'#000',}"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange">
            <el-table-column
              prop="imei"
              label="IMEI"
              >
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              >
            </el-table-column>
            <el-table-column
            label='所属单位'
            >
            <template #default="scope">
                <span v-if="scope.row.alias != null">{{scope.row.alias}}</span>
                <span v-else>{{scope.row.userName}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phoneNumber"
              label="设备手机号"
              >
            </el-table-column >
            <el-table-column
              prop="operator"
              label="操作用户"
              >
            </el-table-column>
            <el-table-column
              label="日志类型"
              >
              <template #default="scope">
                <span v-if="scope.row.type == 1">解绑</span>
                <span v-if="scope.row.type == 2">删除终端</span>
                <span v-if="scope.row.type == 3">更换ICCD</span>
                <span v-if="scope.row.type == 4">大象告警信息通知</span>
                <span v-if="scope.row.type == 5">亲情号码</span>
                <span v-if="scope.row.type == 6">定位频率</span>
                <span v-if="scope.row.type == 7">休眠设置</span>
                <span v-if="scope.row.type == 8">闹钟</span>
                <span v-if="scope.row.type == 9">上课禁用</span>
                <span v-if="scope.row.type == 10">切换IP</span>
                <span v-if="scope.row.type == 11">SOS</span>
                <span v-if="scope.row.type == 12">OPERATOR</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="description"
              label="日志说明"
              >
            </el-table-column>
            <el-table-column
              prop="created"
              label="日志时间"
              >
            </el-table-column>
           
          </el-table>
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
  
      </div>
    </div>
  </template>
  
  <script>
  import { statisticalLogList } from '@/assets/api/api'
  export default {
    components: {

    },
    data () {
      return {
        loading:true,
        Dform: {
            titleValue: '',
            schoolValue: '',
            startTime : '',
            terminalTime: '',
        },
        matchTime: [],
        tableData: [],
        multipleSelection: [],
        pageInfo: {
            page: 1,
            pageSize: 8,
        },
        total: 0
      }
    },
    created() {
        this.searchList()
    },
    methods: {
        searchList ( ) {
            let params = {
              endTime:this.Dform.terminalTime,
              startTime:this.Dform.startTime,
              imei:this.Dform.titleValue,
              name:this.Dform.schoolValue,
              page: this.pageInfo.page,
              pageSize: this.pageInfo.pageSize,
              userId: JSON.parse(localStorage.getItem('user')).id,
            }
            statisticalLogList(params).then((res)=> {
              this.tableData = res.data.list
              this.total = res.data.total
              this.loading = false
            }).catch((err)=> {
                console.log(err);
            })
        },
        inquiryClick( ) {
          this.pageInfo.page = 1
          this.pageInfo.pageSize = 8
          this.total = 0
          this.searchList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection,val,'this.multipleSelection');
        },
        handleSizeChange (val) {
            console.log(`${val} items pr page`)
        },
        handleCurrentChange (val) {
          this.pageInfo.page = val
          this.searchList()
        },
        affirm (item) {
            console.log('确认',item);
        },
    },
    filters: {
    }
  }
  </script>
  
  <style lang='scss' scoped>
  .fuzzy-matching-box {
    width: 100%;
    height:  96%;

    .fuzzy-matching-top {
      height: 100px ;
      background-color: #fff;
      border-radius: 15px;
      display: flex;
      align-content: space-around;  
      align-items: center;
      .titleStyle{
        margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 35%;
      }

        /deep/ {
          .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
          .el-select--small {
              width: 100%
          }
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;     
            font-weight: 700;     
            font-size: 16px;
          }
          .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
          .el-input {
            width: 100%;
            height: 35px;
          }
      }
      .the-second-line {
        margin-top: 15px;
        position: relative;
        .query-button {
          position: absolute;
          right: 35px;
          padding: 16px 24px;
          // top: 50%;
          // transform: translate(0,-50%);
          // background-color: #1BC896;
          border-radius: 15px;
        }
      }
      /deep/ {
        .el-range-editor--small.el-input__wrapper {
            height: 35px;
            line-height: 35px;  
        }
        // .el-icon svg {
        //     display: none;
        //     width: 0px;
            
        // }
        // .el-icon {
        //     width: 0px;
        // }
        // .el-date-editor .el-range-separator {
        //     flex: 0.5;
        // }
       
      }
    }
    .fuzzy-matching-bottom {
      height:85%;
      overflow: auto;
      position: relative;
      padding: 0px 20px;
      padding-top: 30px;
      margin-top: 15px;
      background-color: #fff;
      border-radius: 15px;
        .table-Style{
          font-size: 16px;
          // border-radius: 15px;
        }
        .top-first-line {
        height: 45px;
        line-height: 45px;
          /deep/ .tip-button {
            padding: 14px 14px;
            margin: 0px 3px;
          }
        .import-export-button {
          position: absolute;
          right: 20px;
          /deep/ .el-button--small {
            padding: 16px 24px;
            border: 1px solid #569CFF;
            color: #569CFF;
          }
        }
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
       .fenye {
        // float: right;
        text-align: center;
       }
        /deep/ {
    
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            user-select: initial;
            font-size: 16px;
            color: black;


          }
           .manipulate {
            color: red;
            margin-right:15px;
            cursor: pointer;
            user-select: none;
          }
          .confirm,.duplicate,.revise {
            color:#1677FF;
            
          }
          .el-table th.el-table__cell>.cell {
            text-align: center;
            font-weight: 700;
          }
          .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
            text-align: center;
          }
        }
        .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
    
  }
  </style>
  